// @generated by protoc-gen-connect-es v1.6.1 with parameter "target=ts,import_extension=none"
// @generated from file documents/v3alpha/resources.proto (package com.seed.documents.v3alpha, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetResourceRequest, Resource } from "./resources_pb";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Service for querying Hypermedia resources.
 *
 * Note: This API had to be separate to avoid circular dependencies between documents and comments.
 *
 * @generated from service com.seed.documents.v3alpha.Resources
 */
export const Resources = {
  typeName: "com.seed.documents.v3alpha.Resources",
  methods: {
    /**
     * Gets a single resource with a URL (technically IRI).
     *
     * @generated from rpc com.seed.documents.v3alpha.Resources.GetResource
     */
    getResource: {
      name: "GetResource",
      I: GetResourceRequest,
      O: Resource,
      kind: MethodKind.Unary,
    },
  }
} as const;

